import { Constants } from '../../shared/utils/constants';
import { DataMap } from '../../shared/utils/dataMapping';
import { getProductByUrlKey } from '@shared/utils/appUtils';
const convertPartnerDocument = (d)=>({
        DocumentName: d.documentName,
        DocumentUri: d.documentUri
    });
const convertPartnerImage = (i)=>({
        ImageName: i.imageName,
        ImageUri: i.imageUri
    });
const convertPartnerVideo = (v)=>({
        ThumbnailURL: v.thumbnailUrl,
        VideoLink: v.videoLink,
        VideoName: v.videoName
    });
function attemptMap(a, f) {
    if (a) {
        return a.map(f);
    } else {
        return [];
    }
}
export const parsePartnerApp = (app, product)=>{
    let detailInformation = null;
    if (app.details) {
        const d = app.details;
        detailInformation = {
            AdditionalPurchasesRequired: d.additionalPurchasesRequired,
            AppVersion: d.appVersion,
            CollateralDocuments: attemptMap(d.collateralDocuments, convertPartnerDocument),
            Countries: d.countries,
            DemoVideos: attemptMap(d.demoVideos, convertPartnerVideo),
            Description: d.description,
            HelpLink: d.helpLink,
            Images: attemptMap(d.images, convertPartnerImage),
            Keywords: d.keywords,
            LanguagesSupported: d.languagesSupported,
            LargeIconUri: d.largeIconUri,
            PlatformVersion: d.platformVersion,
            PrivacyPolicyUrl: d.privacyPolicyUrl,
            ReleaseDate: d.releaseDate,
            Subcategories: d.subCategories,
            SupportLink: d.supportLink
        };
    }
    let builtFor = '';
    let productMask;
    const productInfo = getProductByUrlKey({
        urlKey: product
    });
    if (productInfo === null || productInfo === void 0 ? void 0 : productInfo.UrlKey) {
        builtFor = productInfo.LongTitle;
        productMask = {
            [productInfo.FilterGroup]: productInfo.FilterID
        };
    }
    const appDataItem = {
        entityId: app.applicationId,
        title: app.title,
        publisher: app.publisher,
        shortDescription: app.shortDescription,
        builtFor,
        iconURL: app.smallIconUri,
        iconBackgroundColor: app.iconBackgroundColor,
        actionString: Constants.ActionStrings.Get,
        ctaTypes: [
            Constants.CTAType.Get
        ],
        primaryProduct: productMask,
        privateApp: app.privateApp,
        products: app.products ? app.products : productMask,
        industries: app.industries ? app.industries : 0,
        categories: app.categories ? app.categories : 0,
        handoffURL: app.handOffURL,
        leadgenEnabled: app.enableLeadSharing,
        licenseTermsUrl: app.licenseTermsUrl,
        detailInformation,
        filtermatch: true,
        detailLoadFailed: false
    };
    return appDataItem;
};
export const parsePartnerApps = (appData, embedHost)=>{
    let product = embedHost;
    if (embedHost === DataMap.products.Dynamics365.UrlKey) {
        product = DataMap.products.PowerApps.UrlKey;
    }
    const appList = appData.map((a)=>parsePartnerApp(a, product));
    // TODO: sort?
    // PowerBI Apps are wanting to be sorted alphabetically
    /* appList = appList.sort((a: IAppDataItem, b: IAppDataItem) => {
        let aTitle = a.title.toLowerCase();
        let bTitle = b.title.toLowerCase();
        return aTitle > bTitle ? 1 : ( aTitle < bTitle ? -1 : 0 );
    }); */ return appList;
};
